<!--
 * @Descripttion: 资源文件选择器(弹窗选择)
 * @version: 1.0
 * @Author: lybbn
 * @Date: 2024-08-07
 * program django-vue-lyadmin
 * email: 1042594286@qq.com
-->
<template>
	<LyDialog v-model="dialogVisible" :title="dialogTitle" width="70%" :before-close="handleClose" :showFullscreen="false">
        <lyFileSelect v-model="file" :multiple="multiple" :hideUpload="hideUpload" :max="99" @submit="submit">
            <template #custom_do>
                <el-button @click="handleClose">取消</el-button>
            </template>
        </lyFileSelect>
    </LyDialog>
</template>

<script setup>
    import {ref} from "vue"
    import LyDialog from "@/components/dialog/dialog.vue";
    import lyFileSelect from '@/components/file-select/lyfile-select.vue'
    import { ElMessage } from "element-plus";

    const emits = defineEmits(['closed'])

    let dialogTitle = ref("")
    let dialogVisible = ref(false)

    const props = defineProps({
        multiple: {
            type: Boolean,
            default: false
        },
        hideUpload: {
            type: Boolean,
            default: false
        },
    })


    function handleClose(){
        emits('closed')
    }

    let file = ref("")
    function handleOpen(item,flag){
        dialogVisible.value = true
        dialogTitle.value = flag
    }

    function submit(value){
        ElMessage.success("选择了："+value)
        handleClose()
    }
	
    defineExpose({
        handleOpen
    })
</script>

<style lang="scss" scoped>

</style>